import React from "react";

export default ({ color = "black", opacity = "0.8", borderColor = "fff", className = "", onClick = () => {} }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    className={className ? className : ""}
    onClick={onClick}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="addmusic">
      <circle id="Ellipse 4" cx="15" cy="15" r="13" fill="#FDFDFD" />
      <g id="icon/image/audiotrack_24px">
        <path
          id="icon/image/audiotrack_24px_2"
          d="M15.5 8.5V16.4125C15.0575 16.1575 14.5475 16 14 16C12.3425 16 11 17.3425 11 19C11 20.6575 12.3425 22 14 22C15.6575 22 17 20.6575 17 19V11.5H20V8.5H15.5Z"
          fill={color}
          fillOpacity={opacity}
        />
      </g>
    </g>
  </svg>
);
